import React from 'react';
import './OurPlatformBonvoySection.css';
import { brandsData } from './BrandsData';
import OptimizedImage from './OptimizedImage';
import avgDaysStayImg from 'url:../../assets-optimized/redesign/ourDifference/powered/avg_days_stay.png';
import avgDaysStayImgavif from 'url:../../assets-optimized/redesign/ourDifference/powered/avg_days_stay.avif';
import avgDaysStayImgwebp from 'url:../../assets-optimized/redesign/ourDifference/powered/avg_days_stay.webp';
import hotelBrandsInLuxuryImg from 'url:../../assets-optimized/redesign/ourDifference/powered/hotel_brands_in_luxury.png';
import hotelBrandsInLuxuryImgavif from 'url:../../assets-optimized/redesign/ourDifference/powered/hotel_brands_in_luxury.avif';
import hotelBrandsInLuxuryImgwebp from 'url:../../assets-optimized/redesign/ourDifference/powered/hotel_brands_in_luxury.webp';
import loyaltyRatedImg from 'url:../../assets-optimized/redesign/ourDifference/powered/loyalty_rated.png';
import loyaltyRatedImgavif from 'url:../../assets-optimized/redesign/ourDifference/powered/loyalty_rated.avif';
import loyaltyRatedImgwebp from 'url:../../assets-optimized/redesign/ourDifference/powered/loyalty_rated.webp';
import memberCountImg from 'url:../../assets-optimized/redesign/ourDifference/powered/member_count.png';
import memberCountImgavif from 'url:../../assets-optimized/redesign/ourDifference/powered/member_count.avif';
import memberCountImgwebp from 'url:../../assets-optimized/redesign/ourDifference/powered/member_count.webp';

const featureCards = [
  {
    theme: 'orange',
    title: 'Where Loyalty Meets Opportunity',
    description:
      'Our members are planners, bookers, and spenders. With millions of interactions each year, your brand can activate inside a high-frequency, high-value travel ecosystem.',
    tiles: [
      {
        type: 'stat',
        value: '250M',
        label: 'Bonvoy members',
        tone: 'dark',
        tileClassName: 'is-tall',
      },
      {
        type: 'image',
        image: {
          avif: memberCountImgavif,
          webp: memberCountImgwebp,
          fallback: memberCountImg,
        },
        alt: 'Guests relaxing outdoors at a Marriott destination',
        tileClassName: 'is-tall',
      },
      {
        type: 'overlay',
        image: {
          avif: avgDaysStayImgavif,
          webp: avgDaysStayImgwebp,
          fallback: avgDaysStayImg,
        },
        alt: 'Guests dining together',
        value: '2+',
        label: 'Avg. Days Stayed',
        detail: 'For Ambassadors: 3.1 Days',
        tileClassName: 'is-wide',
      },
      {
        type: 'stat',
        value: '93M',
        label: 'Leisure travelers',
        tone: 'dark',
      },
      {
        type: 'stat',
        value: '105M',
        label: 'Business travelers',
        tone: 'dark',
      },
    ],
  },
  {
    theme: 'blue',
    title: 'Portfolio of Amazing Experiences',
    description:
      'With curated experiences across the globe, travelers engage with us constantly—before, during, and after every trip.',
    tiles: [
      {
        type: 'stat',
        value: '#1',
        label: 'Rated Loyalty Program',
        tone: 'light',
        tileClassName: 'is-tall',
      },
      {
        type: 'image',
        image: {
          avif: loyaltyRatedImgavif,
          webp: loyaltyRatedImgwebp,
          fallback: loyaltyRatedImg,
        },
        alt: 'Marriott Bonvoy guests enjoying a snow experience',
        tileClassName: 'is-tall',
      },
      {
        type: 'overlay',
        image: {
          avif: hotelBrandsInLuxuryImgavif,
          webp: hotelBrandsInLuxuryImgwebp,
          fallback: hotelBrandsInLuxuryImg,
        },
        alt: 'Marriott brand portfolio in luxury, premium, select and extended stay segments',
        value: '30+',
        label: 'Hotel Brands In Luxury, Premium, Select and Extended Stay segments',
        tileClassName: 'is-wide',
        tone: 'dark',
      },
      {
        type: 'stat',
        value: '1.7M',
        label: 'Rooms in 150 Countries',
        tone: 'light',
      },
      {
        type: 'stat',
        value: '$1.4B',
        label: 'Food & Beverage Spending in North America',
        tone: 'light',
      },
    ],
  },
];

const brandCategoryOrder = ['Luxury', 'Premium', 'Select', 'Midscale', 'Longer Stays'];

const brandCategories = brandCategoryOrder
  .map((title) => brandsData.find((category) => category.title === title))
  .filter(Boolean);

const ArrowDownIcon = () => (
  <svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M16 3.9987L16 27.332'
      stroke='#171717'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M3.76945 15.77L15.9995 28L28.9687 15.0308'
      stroke='#171717'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

const renderFeatureTile = (tile, index) => {
  if (tile.type === 'image') {
    return (
      <div
        key={`${tile.type}-${index}`}
        className={`od-bonvoy-tile od-bonvoy-tile--image ${tile.tileClassName || ''}`}
      >
        <OptimizedImage
          className={`od-bonvoy-tile-image ${tile.imageClassName || ''}`}
          avif={tile.image.avif}
          webp={tile.image.webp}
          fallback={tile.image.fallback}
          alt={tile.alt}
        />
      </div>
    );
  }

  if (tile.type === 'overlay') {
    return (
      <div
        key={`${tile.type}-${index}`}
        className={`od-bonvoy-tile od-bonvoy-tile--overlay ${tile.tileClassName || ''}`}
      >
        <OptimizedImage
          className={`od-bonvoy-tile-image ${tile.imageClassName || ''}`}
          avif={tile.image.avif}
          webp={tile.image.webp}
          fallback={tile.image.fallback}
          alt={tile.alt}
        />
        <div className={`od-bonvoy-overlay-card ${tile.tone === 'dark' ? 'is-dark' : ''}`}>
          <div className='od-bonvoy-overlay-value'>{tile.value}</div>
          <div className='od-bonvoy-overlay-label'>{tile.label}</div>
          {tile.detail && <div className='od-bonvoy-overlay-detail'>{tile.detail}</div>}
        </div>
      </div>
    );
  }

  return (
    <div
      key={`${tile.type}-${index}`}
      className={`od-bonvoy-tile od-bonvoy-tile--stat is-${tile.tone} ${tile.tileClassName || ''}`}
    >
      <div className='od-bonvoy-tile-value'>{tile.value}</div>
      <div className='od-bonvoy-tile-label'>{tile.label}</div>
    </div>
  );
};

const OurPlatformBonvoySection = () => {
  const handleScrollToFeatures = () => {
    const section = document.getElementById('od-bonvoy-feature-grid');
    if (section) {
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section className='od-bonvoy-section'>
      <div className='od-bonvoy-shell'>
        <header className='od-bonvoy-header'>
          <h2 className='od-bonvoy-title'>
            Built on the World’s <br />
            Most Powerful Travel Platform
          </h2>

          <p className='od-bonvoy-header-copy'>
            Powered by Marriott Bonvoy, we connect you to one of the largest, most loyal travel
            communities on the planet. With unparalleled first‑party data, and intent-rich
            behaviors, we deliver the audiences that move brands.
          </p>

          <button
            type='button'
            className='od-bonvoy-scroll'
            onClick={handleScrollToFeatures}
            aria-label='Scroll to Bonvoy highlights'
          >
            <ArrowDownIcon />
          </button>
        </header>

        <div id='od-bonvoy-feature-grid' className='od-bonvoy-feature-grid'>
          {featureCards.map((card) => (
            <article
              key={card.title}
              className={`od-bonvoy-feature od-bonvoy-feature--${card.theme}`}
            >
              <div className='od-bonvoy-feature-copy'>
                <h3 className='od-bonvoy-feature-title'>{card.title}</h3>
                <p className='od-bonvoy-feature-description'>{card.description}</p>
              </div>

              <div className='od-bonvoy-feature-mosaic'>
                {card.tiles.map((tile, index) => renderFeatureTile(tile, index))}
              </div>
            </article>
          ))}
        </div>

        <div className='od-bonvoy-brand-grid'>
          {brandCategories.map((category) => (
            <article key={category.title} className='od-bonvoy-brand-card'>
              <h3 className='od-bonvoy-brand-title'>{category.title}</h3>
              <p className='od-bonvoy-brand-description'>{category.description}</p>

              <div className='od-bonvoy-brand-logos'>
                {category.brands.map((brand) => (
                  <div key={brand.name} className='od-bonvoy-brand-logo'>
                    {brand.svg || brand.name}
                  </div>
                ))}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OurPlatformBonvoySection;
